import React from 'react';
import { useSelector } from 'react-redux';
import { loginData } from '../../stores/auth';
import useDashboardStats from '../../hooks/dashboard/useDashboardStats';
import useTopSalesProducts from '../../hooks/dashboard/useTopSalesProducts';
import useLatestTransactions from '../../hooks/dashboard/useLatestTransactions';
import './dashboard.scss';

const Dashboard = () => {
  const dataLogin = useSelector(loginData);
  const token = dataLogin?.data?.token;

  const { stats, isLoading: statsLoading, error: statsError } = useDashboardStats(token);
  const { products, isLoading: productsLoading, error: productsError } = useTopSalesProducts(token, 5);
  const { transactions, isLoading: transactionsLoading, error: transactionsError } = useLatestTransactions(token, 10);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
    }).format(amount);
  };

  return (
    <div className="dashboard-page" >
      {statsError && <div className="error-message">{statsError}</div>}

      {/* Stats Grid */}
      <div className="stats-grid">
        <div className="stats-card">
          <div className="card-header">
            <span>Total Sales</span>
            {/* <img src="https://placehold.co/40x40/png" alt="profile" className="profile-icon" /> */}
          </div>
          <h3>{statsLoading ? 'Loading...' : formatCurrency(stats.totalSales)}</h3>
        </div>

        <div className="stats-card">
          <div className="card-header">
            <span>Today's Sales</span>
          </div>
          <h3>{statsLoading ? 'Loading...' : formatCurrency(stats.todaySales)}</h3>
        </div>

        <div className="stats-card">
          <div className="card-header">
            <span>Total Customer</span>
          </div>
          <h3>{statsLoading ? 'Loading...' : stats.totalCustomers}</h3>
        </div>

        <div className="stats-card">
          <div className="card-header">
            <span>Total Products</span>
          </div>
          <h3>{statsLoading ? 'Loading...' : stats.totalProducts}</h3>
        </div>

        <div className="stats-card">
          <div className="card-header">
            <span>Pending Transactions</span>
          </div>
          <h3>{statsLoading ? 'Loading...' : stats.pendingTransactions}</h3>
        </div>

        <div className="stats-card">
          <div className="card-header">
            <span>Confirmed Transactions</span>
          </div>
          <h3>{statsLoading ? 'Loading...' : stats.confirmedTransactions}</h3>
        </div>

        <div className="stats-card">
          <div className="card-header">
            <span>Canceled Transactions</span>
          </div>
          <h3>{statsLoading ? 'Loading...' : stats.canceledTransactions}</h3>
        </div>

        <div className="stats-card">
          <div className="card-header">
            <span>Refund List</span>
          </div>
          <h3>{statsLoading ? 'Loading...' : stats.refundList}</h3>
        </div>
      </div>

      {/* Products Table Section */}
      <section className="products-section">
        <h2>Top Sales Product</h2>
        {productsError && <div className="error-message">{productsError}</div>}
        <div className="products-table">
          {productsLoading ? (
            <div className="loading">Loading products...</div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Total Transactions</th>
                  <th>Total Sales</th>
                </tr>
              </thead>
              <tbody>
                {products.length > 0 ? (
                  products.map((product, index) => (
                    <tr key={product.id || index}>
                      <td>
                        <div className="product-info">
                          <img src={product.image} alt={product.name} />
                          <span>{product.name}</span>
                        </div>
                      </td>
                      <td>{product.totalTransactions}</td>
                      <td>{product.totalSales}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: 'center', padding: '20px' }}>
                      No products data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </section>

      {/* Latest Transactions Section */}
      <section className="latest-transactions">
        <div className="section-header">
          <h2>Latest Transactions</h2>
          <a href="/transactions/confirmed" className="view-all">View All →</a>
        </div>
        {transactionsError && <div className="error-message">{transactionsError}</div>}
        <div className="products-table">
          {transactionsLoading ? (
            <div className="loading">Loading transactions...</div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>Product Name</th>
                  <th>Transaction Date</th>
                  <th>Total Transaction</th>
                  <th>Order Status</th>
                  <th>Payment Status</th>
                </tr>
              </thead>
              <tbody>
                {transactions.length > 0 ? (
                  transactions.map((transaction, index) => (
                    <tr key={transaction.id || index}>
                      <td>{transaction.id}</td>
                      <td>
                        <div className="product-info">
                          {/* <img src="https://placehold.co/60x60/png" alt="product" /> */}
                          <span>{transaction.productName}</span>
                        </div>
                      </td>
                      <td>{transaction.date}</td>
                      <td>{transaction.totalAmount}</td>
                      <td>{transaction.orderStatus}</td>
                      <td>
                        <span className={`status ${transaction.paymentStatus}`}>
                          {transaction.paymentStatus}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                      No transactions available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
